import axios from 'axios';

const API_URL = '/api/educational-content';

export const fetchArticles = async () => {
  const response = await axios.get(`${API_URL}/articles`);
  return response.data;
};

export const fetchVideos = async () => {
  const response = await axios.get(`${API_URL}/videos`);
  return response.data;
};

export const fetchAdvanceDirectiveArticles = async () => {
  try {
    const response = await axios.get(`${API_URL}/advance-directives`);
    return response.data;
  } catch (err) {
    console.error('Error fetching advance directive articles:', err);
    throw err;
  }
}